import React from "react";
import AboutHero from "./heroa";
import ThingsDiff from "./thingsdiff";
import PassionateTeam from "./passionateteam";
import KnownFor from "./knownfor";
import Philosophy from "./philosophy";
import Reasons from "./reasons";
import Ahead from "./ahead";
import BannerMsg from "./bannermsg";

function AboutUs() {
    return (
        <div>
            <AboutHero/>
            <ThingsDiff/>
            <PassionateTeam/>
            <KnownFor/>
            <Philosophy/>
            <Reasons/>
            <Ahead />
            <BannerMsg/>
        </div>

    );
}

export default AboutUs;